// Generated by play/tools/export-coldopen.mjs. Do not edit.
/** Cold open wallpapers (paths relative to the media base), original pixel size. */
export const COLD_OPEN_WALLPAPERS = {
  "portrait": {
    "file": "img/coldopen/wallpaper-portrait.cc946778.webp",
    "width": 1024,
    "height": 1536
  },
  "landscape": {
    "file": "img/coldopen/wallpaper-landscape.fd6bc22a.webp",
    "width": 1536,
    "height": 1024
  }
} as const;
